/**
 * Created by Ning Jiang on 9/26/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";

export class CreepyCarnivalTwoReelAreaView extends ReelAreaView {

    private _reelMasks: PIXI.Graphics[] = [];

    constructor() {
        super();
    }

    protected onResize(resizeData: IResizeData): void {
        let scale: number,
            parent: PIXI.Container,
            reelResizeShiftX: number = 0,
            gameConfig = CreepyCarnivalTwoGameConfig.instance;

        super.onResize(resizeData);
        //const scale:number = Math.min(this._screenWidth / background.texture.width, this._screenHeight / background.texture.height);

        if (this._reelViews.length > 0) {
            parent = this._reelViews[0].parent;

            if (resizeData.orientation !== "portrait") {
                scale = 0.8;

            } else {
                scale = 1.0;
            }

            //parent.scale.set(scale);

            // shift the x of whole reel area so that it compensate for the extra space used between the reels on resizing and to appear as central aligned.
            reelResizeShiftX = ((((gameConfig.REEL_AREA_WIDTH - (gameConfig.SYMBOL_WIDTH * gameConfig.REELS_NUM)) / (gameConfig.REELS_NUM - 1)) - gameConfig.SPACE_BETWEEN_REELS) * ((gameConfig.REELS_NUM - 1) / 2));

            //parent.x += ((parent.width * (10 / (10 * scale))) - parent.width) / 2 + reelResizeShiftX;
            //parent.x += 100;
            //parent.y += CreepyCarnivalTwoGameConfig.instance.PORTRAIT_OFFSET;
        }
    }

    // protected UpdateReelAreaMask():void {
    //     this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
    //         const reelMaskShape:PIXI.Graphics = new PIXI.Graphics();
    //         reelMaskShape.beginFill(0xFFFFF, 1);
    //         if(reelId === 0 || reelId === 4) {
    //             reelMaskShape.drawRect(-130, 150, 260, GameConfig.instance.SYMBOL_HEIGHT * 2 + 40);
    //         } else {
    //             reelMaskShape.drawRect(-105, -20, 210, GameConfig.instance.REEL_AREA_HEIGHT);
    //         }
    //         reelMaskShape.endFill();
    //
    //         if(this._reelMasks[reelId] != null) {
    //             this._reelViews[reelId].removeChild(this._reelMasks[reelId]);
    //         }
    //         this._reelMasks[reelId] = reelMaskShape;
    //         this._reelViews[reelId].addChild(reelMaskShape);
    //         this._reelViews[reelId].mask = reelMaskShape;
    //     });
    // }

    // public addReelView(reel:ReelController):void {
    //     super.addReelView(reel);
    //
    //     if(reel.reelId === 1 && this._reelViews[0] != null) {
    //         this.addChild(this._reelViews[0]);
    //     }
    //
    //     if(reel.reelId === 3 && this._reelViews[4] != null) {
    //         this.addChild(this._reelViews[4]);
    //     }
    // }
}